export default class ScoreCalculator {
    constructor() {
    }
    scoreHand(starterCard, handCards, player) {
        let pointLogs = [];
        let allCards = handCards;
        if(starterCard)  allCards = handCards.concat([starterCard]);
        let pile = "hand";

        let pointsFifteen = this.scoreFifteens(allCards, player, pile);
        pointLogs = pointLogs.concat(pointsFifteen);

        let pointsRuns = this.scoreRuns(allCards, player, pile);
        pointLogs = pointLogs.concat(pointsRuns);

        let pointsPairs = this.scorePairs(allCards, player, pile);
        pointLogs = pointLogs.concat(pointsPairs);

        let pointsFlushes = this.scoreFlush(handCards, starterCard, player, pile);
        pointLogs = pointLogs.concat(pointsFlushes);

        let pointsNobs = this.scoreNob(handCards, starterCard, player, pile);
        pointLogs = pointLogs.concat(pointsNobs);

        return pointLogs;
    }
    scoreCrib(starterCard, cirbCards, player) {
        let pointLogs = [];
        let allCards = cirbCards;
        if(starterCard)  allCards = cirbCards.concat([starterCard]);
        let pile = "crib";

        let pointsFifteen = this.scoreFifteens(allCards, player, pile);
        pointLogs = pointLogs.concat(pointsFifteen);

        let pointsRuns = this.scoreRuns(allCards, player, pile);
        pointLogs = pointLogs.concat(pointsRuns);

        let pointsPairs = this.scorePairs(allCards, player, pile);
        pointLogs = pointLogs.concat(pointsPairs);

        let pointsFlushes = this.scoreCribFlush(allCards, player, pile);
        pointLogs = pointLogs.concat(pointsFlushes);

        let pointsNobs = this.scoreNob(cirbCards, starterCard, player, pile);
        pointLogs = pointLogs.concat(pointsNobs);

        return pointLogs;
    }
    scoreNob(handCards, starterCard, player, pile) {
        let pointLogs = [];

        //-----nob-----------------------------------
        //  one point for holding the Jack of the same suit as the starter card ("one for his nob"[5] or "... his nobs"[6])
        for (let i = 0; i < handCards.length; i++) {
            let card = handCards[i];
            if (starterCard.suit === card.suit && card.number == 11) {
                pointLogs.push({
                    'points': 1,
                    'player': player,
                    'reason': "his nob",
                    'pile': pile,
                    'cards': [card, starterCard]
                });
            }
        }

        return pointLogs;
    }
    scoreFlush(handCards, starterCard, player, pile) {
        let pointLogs = [];
        let allCards = handCards;
        if(starterCard) allCards = handCards.concat([starterCard]);
        //-----flush-------------------------------------
        //  four points for a flush, where all four cards in the hand are of the same suit, with an additional point if the starter card is also of that suit.
        let flushSuit = null;
        let isFlush = true;
        let starterSuit = "";
        if(starterCard) starterSuit = starterCard.suit;
        for (let i = 0; i < handCards.length; i++) {
            let card = handCards[i];
            if (flushSuit === null) flushSuit = card.suit;
            if (flushSuit !== card.suit) isFlush = false;
        }
        if (isFlush  && flushSuit !== starterSuit) {
            pointLogs.push({
                'points': 4,
                'player': player,
                'reason': "Flush 4-card",
                'pile': pile,
                'cards': handCards
            });
        }
        if (isFlush && flushSuit === starterSuit) {
            pointLogs.push({
                'points': 5,
                'player': player,
                'reason': "Flush 5-card",
                'pile': pile,
                'cards': allCards
            });
        }
        return pointLogs;
    }
    scoreCribFlush(cards, player, pile) {
        let pointLogs = [];

        //-----flush (crib)-------------------------------------
        //  four points for a flush, where all four cards in the hand are of the same suit, with an additional point if the starter card is also of that suit.
        //  The rules for scoring the crib are the same as scoring a hand, with the exception of the flush; a four-card flush in the crib is scored only if it is the same suit as the starter card (for a total of five points).
        let flushSuit = null;
        let isFlush = true;
        let cardCount = cards.length;
        for (let i = 0; i < cards.length; i++) {
            let card = cards[i];
            if (flushSuit === null) flushSuit = card.suit;
            if (flushSuit !== card.suit) isFlush = false;
        }
        if (isFlush && cardCount == 5) {
            pointLogs.push({
                'points': 5,
                'player': player,
                'reason': "Flush 5-card",
                'pile': pile,
                'cards': cards
            });
        }
        return pointLogs;
    }
    scoreFifteens(cards, player, pile) {
        let pointLogs = [];

        //------fifteen - twos--------------------------
        //two points for each separate combination of two or more cards totalling exactly fifteen

        let allcombos = this.findAllCombinations(cards, 2);

        //loop through each combo
        for (let i = 0; i < allcombos.length; i++) {
            let combo = allcombos[i];

            //sort cards
            combo = combo.sort(function (a, b) { return a.number - b.number; });

            let total = this.cardsTotal(combo);
            if (total === 15) {
                pointLogs.push({
                    'points': 2,
                    'player': player,
                    'reason': "fifteen",
                    'pile': pile,
                    'cards': combo
                });
            }
        }
        return pointLogs;
    }

    scoreRuns(cards, player, pile) {
        let pointLogs = [];

        //-----runs-------------------------------
        // https://boardgames.stackexchange.com/questions/2403/why-does-a-run-of-4-in-cribbage-score-only-4
        //cant reuse card for 3 in a row in a 4 or 5 run...
        //different length runs cant co-exsit, need to take highest and no subsets
        //1)find run length
        //2)find all combos of that length run
        //3)find all runs
        //  three points for a run of three consecutive cards (regardless of suit)
        //  four points for completing a run of four
        //  five points for completing a run of five
        //1)find run length
        let runLength = this.getHandMaxRunLength(cards);
        //2)get all combo of that length
        let allRunCombos = this.findAllCombinations(cards, runLength, runLength);
        //3)loop through each combo
        for (let i = 0; i < allRunCombos.length; i++) {
            let combo = allRunCombos[i];
            let isRun = this.checkForRun(combo);
            if (combo.length < 3) isRun = false;
            if (isRun) {
                if (combo.length === 3) {
                    pointLogs.push({
                        'points': 3,
                        'player': player,
                        'reason': "run of three",
                        'pile': pile,
                        'cards': combo
                    });
                }
                if (combo.length === 4) {
                    pointLogs.push({
                        'points': 4,
                        'player': player,
                        'reason': "run of four",
                        'pile': pile,
                        'cards': combo
                    });
                }
                if (combo.length === 5) {
                    pointLogs.push({
                        'points': 5,
                        'player': player,
                        'reason': "run of five",
                        'pile': pile,
                        'cards': combo
                    });
                }
            }
        }
        return pointLogs;
    }
    scorePairs(allCards, player, pile) {
        let pointLogs = [];

        //-----pairs-------------------------------
        //  two points for a pair of cards of a kind
        //  six points for three cards of a kind (known as a "pair royal", comprising three distinct pairs)
        //  twelve points for four cards of a kind (a "double pair royal", comprising six distinct pairs)
        for (let number = 1; number <= 13; number++) {
            let pairCount = 0;
            let pairCards = [];
            for (var i = 0; i < allCards.length; i++) {
                let card = allCards[i];
                if (card.number === number) {
                    pairCount += 1;
                    pairCards.push(card);
                }
            }
            if (pairCount === 2) {
                pointLogs.push({
                    'points': 2,
                    'player': player,
                    'reason': "pair",
                    'pile': pile,
                    'cards': pairCards
                });
            }
            if (pairCount === 3) {
                pointLogs.push({
                    'points': 6,
                    'player': player,
                    'reason': "3 of a kind",// (Royal pair)",
                    'pile': pile,
                    'cards': pairCards
                });
            }
            if (pairCount === 4) {
                pointLogs.push({
                    'points': 12,
                    'player': player,
                    'reason': "4 of a kind",// (Double Royal pair)",
                    'pile': pile,
                    'cards': pairCards
                });
            }
        }
        return pointLogs;
    }
    checkForRun(cards) {
        cards = cards.sort(function (a, b) { return a.number - b.number; });
        let lastCardNumber = null;
        for (var i = 0; i < cards.length; i++) {
            let card = cards[i];
            if (lastCardNumber !== null && card.number !== lastCardNumber + 1)
                return false;

            lastCardNumber = card.number;
        }
        return true;
    }
    getHandMaxRunLength(cards) {
        //sort cards
        cards = cards.sort(function (a, b) { return a.number - b.number; });
        let lastCardNumber = null;
        let runCount = 0;
        let maxRunCount = 0;
        for (var i = 0; i < cards.length; i++) {
            let card = cards[i];
            if (card.number === lastCardNumber + 1)
                runCount += 1;
            else if (card.number === lastCardNumber)
                runCount = runCount;
            else
                runCount = 1;

            maxRunCount = Math.max(maxRunCount,runCount);
            lastCardNumber = card.number;
        }
        return maxRunCount;
    }
    cardsTotal(cards) {
        var total = cards.reduce(function (sum, card) {
            return sum + card.value;
        }, 0);
        return total;
    }
    findAllCombinations(a, min, max) {
        if (max === undefined) max = a.length;

        const all = [];
        
        const fn = (n, startIdx, got) => {
            if (n === 0) {
                if (got.length > 0) {
                    all.push(got.slice()); // Copy the array once at the end
                }
                return;
            }
            // Avoid creating new arrays with slice - use index instead
            for (let j = startIdx; j <= a.length - n; j++) {
                got.push(a[j]); // Reuse the same array
                fn(n - 1, j + 1, got);
                got.pop(); // Backtrack
            }
        };
        
        for (let i = min; i <= max; i++) {
            fn(i, 0, []);
        }
        return all;
    }
    scorePeggingPoints(pilePlay, player) {
        //https://en.wikipedia.org/wiki/Rules_of_cribbage
        let pointLogs = [];

        let samesLength = this.getPeggingSamesLength(pilePlay);

        //check for 4 of a kind
        //twelve points for laying a fourth card of the same rank (a "double pair royal" or "quad")
        if (samesLength === 4) {
            pointLogs.push({
                'points': 12,
                'player': player,
                'reason': "quad",
                'pile': "play",
                'cards': pilePlay.slice(-4)
            });
        }

        //check for 3 of a kind
        //six points for laying a third card of the same rank (a "pair royal" or "trips")
        if (samesLength === 3) {
            pointLogs.push({
                'points': 6,
                'player': player,
                'reason': "trips",
                'pile': "play",
                'cards': pilePlay.slice(-3)
            });
        }

        //check for 2 of a kind
        //two points for laying a card of the same rank as the previous card, thus completing a pair
        if (samesLength === 2) {
            pointLogs.push({
                'points': 2,
                'player': player,
                'reason': "pair",
                'pile': "play",
                'cards': pilePlay.slice(-2)
            });
        }


        let runLength = this.getPeggingRunLength(pilePlay);

        //check for run of 7
        //seven points for completing the run of seven; e.g.playing 2, 4, 6, A, 3, 5 and 7
        if (runLength === 7) {
            pointLogs.push({
                'points': 7,
                'player': player,
                'reason': "run of seven",
                'pile': "play",
                'cards': pilePlay.slice(-7)
            });
        }
        //check for run of 6
        //six points for completing a run of six
        if (runLength === 6) {
            pointLogs.push({
                'points': 6,
                'player': player,
                'reason': "run of six",
                'pile': "play",
                'cards': pilePlay.slice(-6)
            });
        }
        //check for run of 5
        //five points for completing a run of five
        if (runLength === 5) {
            pointLogs.push({
                'points': 5,
                'player': player,
                'reason': "run of five",
                'pile': "play",
                'cards': pilePlay.slice(-5)
            });
        }
        //check for run of 4
        //four points for completing a run of four
        if (runLength === 4) {
            pointLogs.push({
                'points': 4,
                'player': player,
                'reason': "run of four",
                'pile': "play",
                'cards': pilePlay.slice(-4)
            });
        }
        //check for run of 3
        //three points for completing a run of three cards, regardless of the order in which they are laid (a 6, then a 4, then a 5 is a run of three even though they were not laid in order)
        if (runLength === 3) {
            pointLogs.push({
                'points': 3,
                'player': player,
                'reason': "run of three",
                'pile': "play",
                'cards': pilePlay.slice(-3)
            });
        }

        //check for total 15
        if (this.cardsTotal(pilePlay) === 15) {
            pointLogs.push({
                'points': 2,
                'player': player,
                'reason': "fifteen",
                'pile': "play",
                'cards': pilePlay
            });
        }

        //check for total 31
        if (this.cardsTotal(pilePlay) === 31) {
            pointLogs.push({
                'points': 2,
                'player': player,
                'reason': "thirty-one",
                'pile': "play",
                'cards': pilePlay
            });
        }


        // //note: check for go? the point given for last card played.  What to do when I play a card and it ends with other player saying "go".  rigth now it know you cant go, so you dont get a "go" option

        // //check for last card
        // if (this.canAnyOnePlay() === false) {
        //     //check for total 31?
        //     if (this.cardsTotal(pilePlay) !== 31) {
        //         pointLogs.push({
        //             'points': 1,
        //             'player': player,
        //             'reason': "last card",
        //             'pile': "play",
        //             'cards': pilePlay
        //         });
        //     }
        // }


        return pointLogs;
    }
    getPeggingSamesLength(cards) {
        if (!cards) return 0;
        if (cards.length === 0) return 0;
        if (cards.length === 1) return 1;
        let same = 0;
        let lastCard = cards[cards.length - 1];

        //loop backwards
        for (let i = cards.length; i--;) {
            let card = cards[i];
            if (lastCard.number === card.number) {
                same += 1;
            } else {
                return same;
            }
        }


        return same;
    }
    getPeggingRunLength(cards) {
        const maxRunLength = 10;
        const minRunLength = 3;
        for (let i = maxRunLength; i > minRunLength - 1; i--) {
            let runLength = i;
            if (cards.length >= runLength) {
                let lastCards = cards.slice(-runLength);
                let orderedCards = lastCards.sort(function (a, b) {
                    return a.number - b.number;
                });
                let isInOrder = true;
                for (let i = 0; i < orderedCards.length - 1; i++) {
                    let card = orderedCards[i];
                    let nextCard = orderedCards[i + 1];
                    if (card.number + 1 !== nextCard.number) {
                        isInOrder = false;
                        break;
                    }
                }
                if (isInOrder) {
                    return runLength;
                }
            }
        }
        return 0;
    }
}